import { Row, Col, Label, Input, Button } from 'reactstrap'
import { formatDate } from '../../../../../../utils'

const PRESETS = [
    { label: 'Today', days: 1, key: 'today' },
    { label: '7d', days: 7, key: '7d' },
    { label: '14d', days: 14, key: '14d' },
    { label: '30d', days: 30, key: '30d' },
]

function DateRangeSelector({
    startDate,
    endDate,
    onStartChange,
    onEndChange,
    activePreset,
    onPresetSelect,
}) {
    const applyPreset = (days, key) => {
        const today = new Date()
        const end = formatDate(today)

        const startDate = new Date()
        startDate.setDate(today.getDate() - (days - 1))
        const start = formatDate(startDate)

        onStartChange(start)
        onEndChange(end)
        onPresetSelect(key)
    }

    return (
        <Row className="align-items-end g-2 " style={{ gap: '8px' }}>
            <Col md="auto">
                <Label for="startDate" className="mb-1">
                    Start Date
                </Label>
                <Input
                    id="startDate"
                    type="date"
                    value={startDate || ''}
                    onChange={(e) => {
                        onStartChange(e.target.value)
                        onPresetSelect(null)
                    }}
                    max={endDate || ''}
                />
            </Col>
            <Col md="auto">
                <Label for="endDate" className="mb-1">
                    End Date
                </Label>
                <Input
                    id="endDate"
                    type="date"
                    value={endDate || ''}
                    onChange={(e) => {
                        onEndChange(e.target.value)
                        onPresetSelect(null)
                    }}
                    min={startDate || ''}
                    max={formatDate(new Date())}
                />
            </Col>
            <Col md="auto" className="d-flex align-items-end" style={{ gap: '8px' }}>
                {PRESETS.map((preset) => (
                    <Button
                        key={preset.key}
                        size="sm"
                        onClick={() => applyPreset(preset.days, preset.key)}
                        disabled={activePreset === preset.key}
                    >
                        {preset.label}
                    </Button>
                ))}
            </Col>
        </Row>
    )
}

export default DateRangeSelector
